import Head from 'next/head'
import { useRouter } from 'next/router'

const HOST = process.env.NEXT_PUBLIC_SITE

export const SEOHead: React.FC<{
  title?: string | number | null
  desc?: string | null
}> = ({ title, desc }) => {
  const router = useRouter()

  const isHome = router.pathname === '/'

  return (
    <Head>
      <title>
        {isHome || !title ? '无界AI-人人都是艺术家' : `${title} | 无界AI`}
      </title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta
        name="description"
        content={
          desc
            ? desc
            : '无界AI，集prompt搜索、AI图库、AI创作、AI广场等为一体。提供一站式AI搜索-创作-交流-分享服务。'
        }
      />
      <link rel="canonical" href={HOST + router.asPath} />
      {isHome && (
        <meta
          name="keywords"
          content="AI描述,描述词搜索,AI创作,prompt搜索,图库,社区,广场"
        />
      )}
    </Head>
  )
}
